import { computed, ref } from "vue";

import { PageType } from "@reco/service/src/utils/pageType";
import { getContextId } from "@reco/service/src/utils/params";
import { Scenario } from "@reco/shared/src/constants";
import { type Recommendation } from "@reco/shared/src/types/recommendation";
import { useFeatureToggle } from "@reco/widgets/src/composables/useFeatureToggle.ts";
import { usePageStore } from "@reco/widgets/src/stores/pageStore";

type UseShopAsstEntryPointParams = {
  recommendations: Recommendation[];
  scenario: Scenario;
  showEntryPoint?: boolean;
};

const ELEMENT_NAME = "sa-entry-point";

export function useShopAsstEntryPoint(params: UseShopAsstEntryPointParams) {
  // Task: make country and pageType reactive
  const { country, pageType } = usePageStore();
  const { isFeatureEnabled } = useFeatureToggle(country);

  const isElementRegistered = ref(!!customElements.get(ELEMENT_NAME));
  if (!isElementRegistered.value) {
    customElements.whenDefined(ELEMENT_NAME).then(() => {
      isElementRegistered.value = true;
    });
  }

  const isEntryPointEligible = computed(() => {
    const showOnPDP = params.scenario === Scenario.PRODUCTS && pageType === PageType.PDP;
    return (showOnPDP || params.showEntryPoint === true) && isElementRegistered.value && isFeatureEnabled("shopAsst");
  });

  const showShopAsstEntryPoint = (index: number) => {
    const isLastItem = index === params.recommendations.length - 1;
    return isEntryPointEligible.value && isLastItem;
  };

  const shopAsstContext = computed(() => {
    const sliderProductErps = params.recommendations?.map((item) => item.erpNumber) || [];
    const entityId = pageType === PageType.PDP ? getContextId(pageType, globalThis.location.pathname) : undefined;
    return JSON.stringify({
      sliderProductErps,
      entityId,
    });
  });

  return {
    showShopAsstEntryPoint,
    shopAsstContext,
  };
}
